import { LENGTH_LABELS } from "rtr-constants";

export const findPreferredSkuObj = (availability, preferredSizes, skus, includeUnavailableSize = false) => {
  if (Array.isArray(preferredSizes) && preferredSizes.length > 0) {
    const preferredAvailableSku = skus.find(o => {
      const availabilitySkuObj = availability.find(a => a.sku === o.sku);

      const isSkuAvailable = includeUnavailableSize || availabilitySkuObj?.availableCount > 0;
      const isUserPreferredSize = o?.canonicalSize?.some(item => preferredSizes.includes(item));

      return isSkuAvailable && isUserPreferredSize;
    });
    return preferredAvailableSku || null;
  }

  return null;
};

export const getSizeMap = skus => {
  return Array.isArray(skus)
    ? skus.reduce((acc, item) => {
        const sku = item?.sku;
        const text = item?.sizeDisplayText;

        if (sku && sku.includes("_") && text) {
          const suffix = sku.split("_").pop();
          acc[suffix] = text;
        }

        return acc;
      }, {})
    : {};
};

export const hasLengthVariants = skus => {
  return (
    Array.isArray(skus) &&
    skus.some(({ sku }) => {
      if (typeof sku !== "string") return false;

      const suffix = sku.split("_").pop();
      const lastChar = suffix?.slice(-1)?.toUpperCase();
      return lastChar === "R" || lastChar === "P";
    })
  );
};

export const getLengthDisplayFromSku = sku => {
  if (!sku || !sku.includes("_")) return null;

  const suffix = sku.split("_").pop();
  const lastChar = suffix.slice(-1).toUpperCase();

  return ["R", "P", "L"].includes(lastChar) ? LENGTH_LABELS[lastChar] || lastChar : null;
};

export const organizeSkusBySizeAndLength = skus => {
  const grouped = {};

  skus.forEach(sku => {
    const key = sku.canonicalSize?.join("-");
    if (!key) return;

    const lengthType = getLengthDisplayFromSku(sku.sku);
    const displayText = sku.sizeDisplayText?.split(",")[0]?.trim();

    if (!grouped[key]) {
      grouped[key] = {
        displayText,
        lengths: {},
      };
    }

    if (!grouped[key].lengths[lengthType]) {
      grouped[key].lengths[lengthType] = [];
    }

    grouped[key].lengths[lengthType].push(sku);
  });

  return grouped;
};

export function sortOrganizedSkusByCanonicalSize(entries) {
  const getMinSize = val => {
    const allSkus = Object.values(val?.lengths || {}).flat();
    const firstCanonical = allSkus[0]?.canonicalSize?.[0];

    if (firstCanonical === "00") return -1;

    return parseInt(firstCanonical, 10);
  };

  return entries.sort(([, aVal], [, bVal]) => {
    return getMinSize(aVal) - getMinSize(bVal);
  });
}

export const getAvailableLengthsFromSkus = skus => {
  const lengths = new Set();

  skus.forEach(sku => {
    const lengthType = getLengthDisplayFromSku(sku.sku);
    lengths.add(lengthType);
  });

  return Array.from(lengths);
};

export const getPreferredLengthType = (availableLengths, preferred = "Regular") => {
  return availableLengths.includes(preferred) ? preferred : availableLengths[0] ?? null;
};

export const getSizeLabel = (sku, organizedSkus, hasLengthVariants) => {
  if (!sku) return "";

  const key = sku.canonicalSize?.join("-");
  const displayText = sku.sizeDisplayText?.split(",")[0]?.trim() || organizedSkus?.[key]?.displayText;

  const lengthType = getLengthDisplayFromSku(sku.sku);

  return hasLengthVariants && lengthType ? `${displayText}, ${lengthType}` : displayText;
};
